export default __webpack_public_path__ + "static/21-a4718abe1c27aa2b3f8f7901085a2b63.png";